import { C } from "./theme";

// The large ◀ at the left of every page's top bar but Home's: it always goes back to Home (Craig, 24 Oct 2026: "a
// large 'back' chevron to the left of the page title … take the user back to Home page"). Drawn as the same solid
// triangle the folds use (▼), turned to point left; an SVG, so phones never swap in an emoji. Pages without the top
// bar draw it too, going back where they came from (Craig, 24 Oct 2026: "add the new bold chevron to the top left
// 'back' button" on the Goal page); `label` says where.
export function BackButton({ onClick, label = "Back to Home" }) {
  return (
    <button onClick={onClick} aria-label={label} title={label}
      style={{ width: 44, height: 44, flexShrink: 0, margin: "0 0 0 -14px", display: "grid", placeItems: "center", padding: 0, border: "none", background: "none", cursor: "pointer", color: C.text }}>
      <svg aria-hidden="true" width="16" height="20" viewBox="0 0 16 20"><path d="M14 2 L3 10 L14 18 Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" /></svg>
    </button>
  );
}
